<template>
 <div class="custom-dialog" :style="{left: $vuetify.application.left+'px'}">
    <div class="custom-dialog-container">
      <div class="custom-dialog-closer"></div>
      <v-container fluid>
        <v-row>
          <v-col>
            <v-form v-model="valid" id="valid" ref="form">
              <!-- <o-progress v-if="loading"/> -->
              <pop-up-layout :title="titulo" :description="pregunta">
                <v-layout column justify-center align-center>
                  <v-textarea
                    v-model="motivos" id="motivos"
                    rows="5"
                    style="width: 80%"
                    :rules="[rules.obligatorio, rules.min(20)]"
                  />
                </v-layout>
                <v-layout wrap justify-center align-center slot="acciones">
                  <v-btn
                    class="mx-3"
                    color="error" 
                    @click="$emit('cancelar',false)"
                  >
                    {{cancelar}}
                  </v-btn>
                  <v-btn
                    class="mx-3"
                    color="primary" 
                    @click="comprobarFormulario()"
                  >
                    {{aceptar}}
                  </v-btn>
                </v-layout>
              </pop-up-layout>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import rulesMixin from '@/components/generic/rules.js'
import { mapActions } from 'vuex'
  export default {
    mixins: [rulesMixin],
    props: {
      titulo: {
        type: String,
        default () {
          return this.$t('popUps.pv1.titulo')
        }
      },
      pregunta: {
        type: String,
        default () {
          return this.$t('popUps.pv1.subtitulo')
        }
      },
      aceptar: {
        type: String,
        default () {
          return this.$t('popUps.pv1.aceptar')
        }
      },
      cancelar: {
        type: String,
        default () {
          return this.$t('popUps.pv1.cancelar')
        }
      }
    },
    data () {
      return {
        motivos: '',
        valid: false
      }
    },
    methods: {
      ...mapActions({
        addAlert: 'alerts/add'
      }),
      comprobarFormulario() {
        this.$refs.form.validate()
        if (!this.valid) {
          this.addAlert({texto: this.$t('popUps.pv1.mensajeCorto'), color: 'error'})
        } else {
          this.$emit('aceptar', this.motivos)
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  .custom-dialog
    position: fixed
    top: 0
    bottom: 0
    right: 0
    left: 0
    z-index: 6
    overflow-y: scroll
    transition-property: transform, width, -webkit-transform
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1)

  .custom-dialog-container
    position: relative
    min-height: 100%
    width: 100%
    display: flex
    align-content: center

  .custom-dialog-closer
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background-color: rgba(0,0,0,.8)
    &:hover
      cursor: pointer

</style>
